import { localeAtom } from '@core/Atoms/Locale/Locale.atom';
import { LoadingBackground } from '@core/Components/LoadingBackground/LoadingBackground';
import { Typography } from '@gds/Typography/Typography';
import { useAtomValue } from 'jotai';
import Link from 'next/link';
import { CalculatorMessages } from '../FinancingCalculator/Calculator.messages';
import styles from './Header.module.css';

type Props = {
  strings: CalculatorMessages;
};

export const LoadingHeader = ({ strings }: Props) => {
  const locale = useAtomValue(localeAtom);

  return (
    <header className={styles.header}>
      <Typography variant="h3">{strings.wantToPayMonthly}</Typography>

      <Typography variant="body4" Component="p">
        {strings.introHeader}
      </Typography>

      {locale === 'uk' && (
        <Link className={styles.link} target="_blank" href={'/'}>
          {strings.findOut}
        </Link>
      )}

      <div className={styles.products}>
        <div className={styles.product}>
          <LoadingBackground />
        </div>
        <div className={styles.product}>
          <LoadingBackground />
        </div>
      </div>
    </header>
  );
};
